import { render, staticRenderFns } from "./OrderedDelivered.vue?vue&type=template&id=29b7215e&"
import script from "./OrderedDelivered.ts?vue&type=script&lang=js&"
export * from "./OrderedDelivered.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports